import { type FetchCarrierAccountPayload } from '~/actions/carrier-accounts.actions';
import api, { armorAPI } from '~/services/api';
import { type JSONCarrier } from '~/types/Carrier';
import {
  type CarrierServiceLevelsEditPayload,
  type JSONCarrierAccount,
  type JSONCreateCarrierAccount,
} from '~/types/CarrierAccount';
import { type JSONCarrierAccountRegStatus } from '~/types/CarrierAccountRegStatus';

export const getCarrierAccounts = (payload?: FetchCarrierAccountPayload) =>
  api.request<{ results: JSONCarrierAccount[] }>({
    method: 'GET',
    params: {
      /* results: X, Default solution; otherwise, only 5 results are returned.
      Does not return 999 -> 'MAX_PAGINATE_BY': 200 hardcoded limit on back end */
      results: 999,
      ...payload,
    },
    url: '/carrier_accounts',
  });

export const getCarrierProviders = (carriers: string[]) =>
  armorAPI.request<{ results: { carriers: JSONCarrier[] } }>({
    method: 'GET',
    params: {
      carriers,
    },
    url: '/setting/carriers',
  });

export const connectCarrierAccount = (carrierAccount: JSONCarrierAccount) =>
  api.request<JSONCarrierAccount>({
    data: {
      ...carrierAccount,
    },
    method: 'POST',
    url: '/carrier_accounts',
  });

export const uploadCompanyLogo = (accountObjectId: string, companyLogo: Blob) => {
  const formData = new FormData();
  formData.append('file', companyLogo);
  formData.append('document_type', 'LETTERHEAD');
  return api.request({
    data: formData,
    method: 'POST',
    url: `/carrier_accounts/${accountObjectId}/documents`,
  });
};

export const uploadDigitalSignature = (accountObjectId: string, digitalSignature: Blob) => {
  const formData = new FormData();
  formData.append('file', digitalSignature);
  formData.append('document_type', 'SIGNATURE');
  return api.request({
    data: formData,
    method: 'POST',
    url: `/carrier_accounts/${accountObjectId}/documents`,
  });
};

export const editCarrierAccount = (carrierAccount: JSONCarrierAccount, id: string) =>
  api.request<JSONCarrierAccount>({
    data: {
      ...carrierAccount,
    },
    method: 'PUT',
    url: `/carrier_accounts/${id}`,
  });

export const editCarrierAccountServiceLevels = (
  carrierServiceLevels: CarrierServiceLevelsEditPayload,
  account_object_id: string,
) =>
  api.request({
    data: carrierServiceLevels,
    method: 'PATCH',
    url: `/carrier_accounts/${account_object_id}/service_levels`,
  });

export const createCarrierAccount = (requestBody: JSONCreateCarrierAccount) =>
  api.request({
    data: {
      ...requestBody,
    },
    method: 'POST',
    url: '/carrier_accounts/register/new',
  });

export const fetchCarrierAccountRegStatuses = () =>
  armorAPI.request<{ results: JSONCarrierAccountRegStatus[] }>({
    method: 'GET',
    url: '/carrier-accounts/reg-status/',
  });

export const initiateOauthConnection = (carrierAcccountObjectId: string) =>
  api.request({
    method: 'GET',
    params: {
      redirect: 'false', // force 200 response
      redirect_uri: `${CONFIG.reactBaseUrl}settings/carriers`,
    },
    url: `/carrier_accounts/${carrierAcccountObjectId}/signin/initiate`,
  });
